module.exports = __webpack_public_path__ + "media/שי.b697d08a.mp3";